export default __webpack_public_path__ + "static/media/our-story-bg.2f99342a.jpg";